import type { FieldNodeStateWithId } from '@leagueplatform/masonry-engine';
import { PostMasonryFormFields } from '../types/post-masonry-form';

export const formatFormFields = (
  fieldNodes: FieldNodeStateWithId[],
): PostMasonryFormFields =>
  fieldNodes.map(({ nodeId, value, formFieldProperties: { formFieldId } }) => ({
    nodeId,
    value,
    formFieldId,
  }));
